module.exports = "/build/web/svg/social/snapchat.3aa164152b373e8c5d2bb606e5956322.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/snapchat.svg
// module id = 199
// module chunks = 24